import React from 'react';
import { AccountSettingsLegalDocs } from '../../../pages/AccountSettings/components/AccountSettingsLegalDocs';

export const LegalDocsBlock = () => <AccountSettingsLegalDocs />;
